import { useState } from 'react';
import { TChainName } from '../types';
import { Contract } from 'ethers';
import { getAggregatorContract } from '../utils';

export function useMulticall(
    chainName: TChainName,
    callParams: string,
    operations: string
): { result: number, multicallError: string, multicall: () => void } {

    const [result, setResult] = useState<number>(0);
    const [multicallError, setError] = useState<string>('');

    const multicall = () => {
        (async () => {

            try {

                const aggregator: Contract = getAggregatorContract(chainName);

                const result_ = await aggregator.multicall(callParams, operations);

                setResult(parseInt(result_.toString()));
                setError('');

            } catch (e: { message: string } | any) {
                setError(e.message);
                console.error("useMulticall", e)
            }

        })().catch((e: { message: string }) => {
            setError(e.message);
            console.error("useMulticall", e)
        })
    }

    return { result, multicallError, multicall }

}